import { API_URL } from "./apiBase";
import {DataSheetConfig, BidConfigWritable} from "../components/project_conf/bidConfig_model";

async function BidConfigSubmit(
    url: string,
    accessToken: string,
    body?: DataSheetConfig | BidConfigWritable,
    method: string = "POST"
) {
    const response = await fetch(url, {
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Failed to ${method} bid config`);
    }

    return response.json();
}

// export async function createBidConfig(
//     project_id: string,
//     accessToken: string,
//     body: BidConfigWritable
// ) {
//     return BidConfigSubmit(
//         `${API_URL}/projects/${project_id}/bid_config/create`,
//         accessToken,
//         body,
//         "POST"
//     );
// }

export async function listBidConfigs(project_id: string, accessToken: string) {
    return BidConfigSubmit(
        `${API_URL}/projects/${project_id}/bid_configs/`,
        accessToken,
        undefined,
        "GET"
    );
}

export async function getBidConfig(project_id: string, config_id: string, accessToken: string) {
    return BidConfigSubmit(
        `${API_URL}/projects/${project_id}/bid_config/${config_id}`,
        accessToken,
        undefined,
        "GET"
    );
}

export async function updateBidConfig(
    project_id: string,
    config_id: string,
    accessToken: string,
    body: BidConfigWritable
) {
    return BidConfigSubmit(
        `${API_URL}/projects/${project_id}/bid_config/${config_id}`,
        accessToken,
        body,
        "PUT"
    );
}

export async function deleteBidConfig(
    project_id: string,
    config_id: string,
    accessToken: string
) {
    return BidConfigSubmit(
        `${API_URL}/projects/${project_id}/bid_config/${config_id}`,
        accessToken,
        undefined,
        "DELETE"
    );
}
